import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeFormOfPaymentCommand extends BaseCommand {
  CommandName = "ChangeFormOfPayment";
  Command: { Value: number };
  constructor(sessionId: string, operationId: string, value: number) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
